import React from "react";
import { Reveal } from "@/components/Reveal";
import { INDIVIDUAL_SERVICES, ADDONS } from "@/data/content";

const PriceRow = ({ label, price, testid }) => (
  <div data-testid={testid} className="flex items-center justify-between py-5 border-t border-[#F6F4F0]/12 group">
    <span className="text-[#E5E7EB] font-light group-hover:text-gold transition-colors">{label}</span>
    <span className="font-heading text-lg text-[#F6F4F0] whitespace-nowrap pl-6">{price}</span>
  </div>
);

export const PriceTables = () => (
  <section id="services-pricing" data-testid="pricing-tables-section" className="py-24 md:py-36 bg-[#0A1521]">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
      <div>
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Add-Ons</p>
          <h2 className="font-heading font-light text-3xl sm:text-4xl text-[#F6F4F0] mb-4 leading-tight">
            Enhance any package.
          </h2>
          <p className="text-[#6B7280] text-sm mb-10">Bolt on extra reach or content to any plan whenever you need it.</p>
        </Reveal>
        <Reveal delay={0.1}>
          <div>
            {ADDONS.map(([label, price], i) => (
              <PriceRow key={label} label={label} price={price} testid={`addon-${i}`} />
            ))}
          </div>
        </Reveal>
      </div>

      <div>
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Individual Services</p>
          <h2 className="font-heading font-light text-3xl sm:text-4xl text-[#F6F4F0] mb-4 leading-tight">
            Book a single service.
          </h2>
          <p className="text-[#6B7280] text-sm mb-10">Not ready for a monthly package? Purchase any service on its own.</p>
        </Reveal>
        <Reveal delay={0.1}>
          <div>
            {INDIVIDUAL_SERVICES.map(([label, price], i) => (
              <PriceRow key={label} label={label} price={price} testid={`individual-service-${i}`} />
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
